export const environment = {
  production: true,
  name: 'prod',
  apiUrls: {
    reports: 'https://do.meander.software:5000/api',
    master: 'https://do.meander.software:5000/api',
    rbUrl: 'https://cms.meander.software',
    rbGqlUrl: 'https://cms.meander.software/graphql',
    imageUrl:"https://do.meander.software:5000/assets/images/",
    pdfUrl:"https://do.meander.software:5000/assets/documents/",
    s3MediaUrl:"https://meandersoftware.s3.eu-north-1.amazonaws.com/",
    baseUrl:'https://do.meander.software',
    course_imageUrl:'https://meandersoftware.s3.amazonaws.com/',

  },
};
